import { ActionType, ProTable } from "@ant-design/pro-components";
import { Button, Image, Select, message } from "antd";
import { useGlobalState } from "../../components/global";
import { useEffect, useRef } from "react";
import UUIDComponent from "../../components/UUIDComponent";
import { businessType } from "../const";

export default function Feedback() {
    const { jsonRequest } = useGlobalState();
    const tableRef = useRef<ActionType>();

    useEffect(() => {
        tableRef.current?.reload();
    }, []);

    const columns: any[] = [
        {
            title: "ID",
            dataIndex: "id",
            align: "center",
            search: false,
            render: (value: any) => <UUIDComponent value={value} />
        },
        {
            title: "用户id",
            dataIndex: "userId",
            align: "center",
            search: false,
            render: (value: any) => <UUIDComponent value={value} />
        },
        {
            title: "联系方式",
            dataIndex: "phone",
            align: "center",
            search: false,
        },
        {
            title: "设备类型",
            dataIndex: "deviceType",
            align: "center",
            search: false,
            width: 100,
            render: (text: string) => (
                <div>{text === 'IOS' ? 'ios' : text === 'ANDROID' ? '安卓' : '未知'}</div>
            )
        },
        {
            title: "业务类型",
            dataIndex: "type",
            align: "center",
            search: true,
            width: 100,
            valueEnum: businessType,
        },
        {
            title: "反馈内容",
            dataIndex: "content",
            align: "center",
            search: false,
        },
        {
            title: "反馈图片",
            dataIndex: "images",
            align: "center",
            search: false,
            width: 250,
            render: (text: any) => {
                if (!text || (Array.isArray(text) && text.length === 0) || (typeof text === 'object' && Object.keys(text).length === 0)) {
                    return '-';
                }
                return (
                    <Image.PreviewGroup>
                        {text.map((item: string, index: number) => (
                            <Image
                                key={index}
                                src={item}
                                width={100}
                                height={100}
                                style={{ marginRight: 8 }}
                            />
                        ))}
                    </Image.PreviewGroup>
                );
            }
        },
        {
            title: "反馈状态",
            dataIndex: "status",
            align: "center",
            search: true,
            width: 100,
            renderFormItem: () => (
                <Select
                    allowClear
                    placeholder='请选择状态'
                    options={[
                        { label: "待处理", value: 'ENABLE' },
                        { label: "已处理", value: 'DISABLE' },
                    ]}
                />
            ),
            render: (text: string) => {
                switch (text) {
                    case "ENABLE":
                        return <span style={{ color: 'orange' }}>待处理</span>;
                    case "DISABLE":
                        return <span style={{ color: 'green' }}>已处理</span>;
                    default:
                        return <span>未知</span>;
                }
            }
        },
        {
            title: "反馈时间",
            dataIndex: "createAt",
            align: "center",
            search: false,
            width: 120,
        },
        {
            title: "反馈时间",
            dataIndex: "createAt",
            align: "center",
            valueType: "dateRange",
            hideInTable: true,
        },
        {
            title: "操作",
            key: 'operation',
            search: false,
            align: "center",
            width: 70,
            render: (_: any, record: any) => {
                if (record.status === 'ENABLE') {
                    return <Button style={{ color: '#58CCE0' }} type="text" onClick={() => changeStatus(record)}>处理</Button>;
                } else if (record.status === 'DISABLE') {
                    return <Button style={{ color: '#F3C017' }} type="text" onClick={() => changeStatus(record)}>取消处理</Button>;
                }

                return null;
            },
        }
    ];

    const changeStatus = async (item: any) => {
        const data: any = await jsonRequest.put(`/back/health-feedback/change-status/suggestion/${item.id}`, {})
            .then((resp: any) => resp.json());
        if (data?.code === 0) {
            tableRef.current?.reload();
            message.success("处理成功");
        } else {
            message.error(data?.msg || "处理失败");
        }
    };

    const init = async (url: any) => {
        const result = await jsonRequest.get(`/common/oss-file-visit-url`, { fileUrl: url })
            .then((resp: any) => resp.json());
        return result?.data;
    };

    const request = async (params: any) => {
        const result: any = await jsonRequest.get("/back/health-feedback/page/suggestion", {
            currentPage: params.current,
            pageSize: params.pageSize,
            queryBeginDate: params?.createAt?.[0],
            queryEndDate: params?.createAt?.[1],
            status: params?.status,
            type: params?.type,
        }).then((resp: any) => resp.json());
        const { data } = result;
        if (data?.data && Array.isArray(data.data)) {
            // 处理每个数据项的图片路径
            const processedData = await Promise.all(data.data.map(async (item: any) => {
                if (item.images && Array.isArray(item.images) && item.images.length > 0) {
                    // 获取每个图片的实际访问URL
                    const processedImages = await Promise.all(
                        item.images.map((imgUrl: string) => init(imgUrl))
                    );
                    return {
                        ...item,
                        images: processedImages
                    };
                }
                return item;
            }));

            return {
                data: processedData,
                success: result.code === 0,
                total: data?.count
            };
        }

        return { data: data?.data, success: result.code === 0, total: data?.count };
    };

    return <>
        <h1>意见反馈</h1>
        <ProTable
            rowKey="id"
            scroll={{ x: 100 }}
            actionRef={tableRef}
            cardBordered
            columns={columns}
            request={request}
            pagination={{ defaultPageSize: 10, showSizeChanger: true }}
            search={{ span: 6, defaultCollapsed: false }}
        />
    </>;
}